import { Box, Text,   Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,  Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    useDisclosure, Button, AspectRatio} from "@chakra-ui/react";
import backgroundTop from "../assets/background-top.png";
import background from "../assets/bg.jpg";
import Menubar from "../components/Menubar";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMyVideo } from "../store/actionCreators/videoAction";
import { ACCENT_1_COLOR } from "../constants/color";

export default function MyLesson() {
    const dispatch = useDispatch();
    const [currentVideo, setCurrentVideo] = useState({});
    const {myVideo} = useSelector((store) => store.rootReducer.videoReducer)
    const {
        isOpen,
        onOpen,
        onClose,
      } = useDisclosure();
    useEffect(() => {
        dispatch(getMyVideo())
    }, [dispatch])

    const videoList = useMemo(() => {
        const allLevel = [
            "Candidate",
            "Mukyu",
            "Gokyu",
            "Yonkyu",
            "Sankyu",
            "Nikyu",
            "Ikkyu",
            "Shodan",
            "Nidan",
            "Sandan",
            "Yondan",
          ];
        const level = myVideo[myVideo.length-1]?.level
        const index = allLevel.findIndex((element) => element === level);
        const selectedLevel = allLevel.slice(0, index+1);
        const groupedData = myVideo.reduce((acc, item) => {
            if (!acc[item.level]) {
              acc[item.level] = [];
            }
            acc[item.level].push(item);
            return acc;
          }, {});
          
        return {selectedLevel, data: groupedData}
    }, [myVideo])

    const handleSeeVideo = (video) => {
        setCurrentVideo(video)
        onOpen();
      }
  
      const handleCloseVideo = () => {
        setCurrentVideo({})
        onClose();
      }


  return (
    <Box
      display={"flex"}
      width={"100vw"}
      minH={"100vh"}
      background={`transparent url(${background})`}
      bgRepeat={"repeat"}
      pb={"24px"}
    >
      <Box
        bgRepeat={"repeat-x"}
        backgroundImage={`url(${backgroundTop})`}
        width={"100vw"}
        height={"auto"}
      >
        <Menubar />
        <Box
          width={"100vw"}
          px={{ base: "5vw", lg: "20vw" }}
          display={"flex"}
          flexDir={"column"}
          textAlign={"left"}
        >
          <Text textColor={ACCENT_1_COLOR} fontSize={"30px"}>
            Mugai Ryu Indonesia
          </Text>
          <Text
            textColor={"#765946"}
            fontStyle={"italic"}
            fontSize={"18px"}
            mb={"24px"}
          >
            My Lessons
          </Text>

        {videoList?.selectedLevel?.length > 0 && videoList?.selectedLevel.map((el) => <Box>
            <Text textColor={ACCENT_1_COLOR} fontSize={"24px"}>{el}</Text>
              <Table mb={"24px"}>
                <Thead>
                  <Tr>
                    <Th w={"120px"}>Level</Th>
                    <Th>Name</Th>
                    <Th w={"240px"}>Group</Th>
                    <Th w={"120px"}>Style</Th>
                    <Th w={"150px"}></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {videoList.data[el]?.length > 0 && videoList.data[el]?.map((le) => <Tr>
                    <Td>{le.level}</Td>
                    <Td>{le.name}</Td>
                    <Td>{le.group}</Td>
                    <Td>{le.style}</Td>
                    <Td><Button colorScheme="blackAlpha" mr={"8px"} onClick={() => handleSeeVideo(le)}>See Video</Button></Td>
                  </Tr>)}
                </Tbody>
              </Table>
        </Box>)}

        
        </Box>
        <Modal
          isOpen={isOpen}
          onClose={handleCloseVideo}
          isCentered
          closeOnOverlayClick={false}
          size={"xl"}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{currentVideo?.group} - {currentVideo?.name}</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={"24px"}>
              <AspectRatio width={"100%"} ratio={16/9}>
                <iframe
                  title={currentVideo.name}
                  src={currentVideo.link}
                  allowFullScreen
                />
              </AspectRatio>
            </ModalBody>
          </ModalContent>
        </Modal>
      </Box>
    </Box>
  );
}
